import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Box, Grid, Stack } from '@mui/material';


// sections
import { LoginForm } from '../sections/auth/login';
import CustomSnackBar from '../components/snackbar';


// ----------------------------------------------------------------------

const LoginPage = () => {

  // snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(null)

  return (
    <>
      <Helmet>
        <title>Login | RMS </title>
      </Helmet>
      <Grid container sx={{ display: 'flex', flexDirection: 'column', alignItems:'center' ,justifyContent: 'center',  }}>

          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems:'center' ,justifyContent: 'center',  }}>
            <Stack spacing={3} sx={{ mb: 3 }}>
           
              <LoginForm  setSnackbarOpen={setSnackbarOpen} setSnackbarMessage={setSnackbarMessage} />
            </Stack>
          </Box>

      </Grid>
      <CustomSnackBar snackbarOpen={snackbarOpen} setSnackbarOpen={setSnackbarOpen} snackbarMessage={snackbarMessage && snackbarMessage.msg} success={snackbarMessage && snackbarMessage.success} />
    </>
  );
}
export default LoginPage;